<h2 mat-dialog-title>New meeting note</h2>

<mat-dialog-content>
  <form [formGroup]="referatForm">
    <div class="container py-3">
      <div class="row mb-3">
        <div class="col-md-12">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Meeting date <span class="text-danger">*</span></mat-label>
            <input
              matInput
              [matDatepicker]="meetingPicker"
              formControlName="meetingDate"
            />
            <mat-datepicker-toggle matSuffix [for]="meetingPicker"></mat-datepicker-toggle>
            <mat-datepicker #meetingPicker></mat-datepicker>
            <mat-error *ngIf="referatForm.get('meetingDate')?.invalid && referatForm.get('meetingDate')?.touched">
              Meeting date is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Notes <span class="text-danger">*</span></mat-label>
          <textarea
            matInput
            rows="12"
            formControlName="text"
            placeholder="Enter notes from the customer meeting"
          ></textarea>
          <mat-error *ngIf="referatForm.get('text')?.invalid && referatForm.get('text')?.touched">
            Notes are required.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div align="end" class="p-3 border-top">
      <button
        mat-raised-button
        color="primary"
        [disabled]="referatForm.invalid"
        (click)="saveReferat()"
      >
        Save
      </button>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  </form>
</mat-dialog-content>
